const e = (r) => String.prototype.normalize ? r.normalize("NFD").replace(/\p{Diacritic}/gu, "") : r, n = (r) => {
  const t = r.trim().toLowerCase();
  return e(t);
};
export {
  n as normalizeString,
  e as stripAccents
};
